package com.kinoshazam.data

import com.russhwolf.settings.Settings

open class StorageImpl(val settings: Settings) {

    inline fun <reified DataType> put(key: String, value: DataType) {
        when (DataType::class) {
            String::class -> settings.putString(key, value as String)
            Int::class -> settings.putInt(key, value as Int)
            Boolean::class -> settings.putBoolean(key, value as Boolean)
            Long::class -> settings.putLong(key, value as Long)
            Float::class -> settings.putFloat(key, value as Float)
            else -> throw IllegalStateException("saveSharedPreference: Wrong data type: ${DataType::class}, name = ${key}, value = ${value.toString()}")
        }
    }

    inline fun <reified DataType> get(key: String): DataType? {
        return when (DataType::class) {
            String::class -> (settings.getStringOrNull(key)) as? DataType
            Int::class -> settings.getIntOrNull(key) as? DataType
            Boolean::class -> settings.getBooleanOrNull(key) as? DataType
            Long::class -> settings.getLongOrNull(key) as? DataType
            Float::class -> settings.getFloatOrNull(key) as? DataType
            else -> throw IllegalStateException("getSharedPreference: Wrong data type: ${DataType::class}.")
        }
    }

    inline fun <reified DataType> get(key: String, default: DataType): DataType {
        return when (DataType::class) {
            String::class -> (settings.getString(key, default as String)) as DataType
            Int::class -> settings.getInt(key, default as Int) as DataType
            Boolean::class -> settings.getBoolean(key, default as Boolean) as DataType
            Long::class -> settings.getLong(key, default as Long) as DataType
            Float::class -> settings.getFloat(key, default as Float) as DataType
            else -> throw IllegalStateException("getSharedPreference: Wrong data type: ${DataType::class}.")
        }
    }

    fun clear() = settings.clear()

    fun remove(key: String) = settings.remove(key)
}